import { useTrackingQuery } from './use-tracking-query';
export var useFeedback = function useFeedback() {
  var _useTrackingQuery$dat;

  return ((_useTrackingQuery$dat = useTrackingQuery().data) === null || _useTrackingQuery$dat === void 0 ? void 0 : _useTrackingQuery$dat.feedbacks) || [];
};